import { render, staticRenderFns } from "./SidenavMenu.vue?vue&type=template&id=85c64be2&"
import script from "./SidenavMenu.vue?vue&type=script&lang=js&"
export * from "./SidenavMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85c64be2')) {
      api.createRecord('85c64be2', component.options)
    } else {
      api.reload('85c64be2', component.options)
    }
    module.hot.accept("./SidenavMenu.vue?vue&type=template&id=85c64be2&", function () {
      api.rerender('85c64be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/vendor/libs/sidenav/SidenavMenu.vue"
export default component.exports